const LIST_DOMAIN_FACEBOOK = [
  'accountkit.com',
  'acebook.com',
  'faacebook.com',
  'facebbook.com',
  'facebookcareers.com',
  'facebook.co',
  'facebook.com',
  'facebook.com.au',
  'facebook.com.mx',
  'facebook-dns.com',
  'facebookenterprise.com',
  'facebook-hardware.com',
  'facebook.it',
  'facebookmail.com',
  'facebook.net',
  'facebookrecruiting.com',
  'facebookstudy.com',
  'facebookvirtualassistant.com',
  'fb.audio',
  'fbcdn.net',
  'fb.com',
  'fbe2e.com',
  'fb.gg',
  'fbinfra.net',
  'fb.me',
  'fbpigeon.com',
  'fbsbx.com',
  'fbthirdpartypixel.com',
  'fb.watch',
  'fbwat.ch',
  'internet.org',
  'm-freeway.com',
  'parse.com',
  'wit.ai',
];

const LIST_DOMAIN_TWITTER = [
  'ads-twitter.com',
  'periscope.tv',
  'pscp.tv',
  't.co',
  'tweetdeck.com',
  'twimg.com',
  'twitpic.com',
  'twitter.co',
  'twitter.com',
  'twitterinc.com',
  'twitteroauth.com',
  'twitterstat.us',
  'twtrdns.net',
  'twttr.com',
  'x.com',
];

const LIST_DOMAIN_LINKEDIN = [
  'bizographics.com',
  'licdn.cn',
  'licdn.com',
  'linkedin.at',
  'linkedin.cn',
  'linkedin.com',
  'linkedinmobileapp.com',
  'linkedin.qtlcdn.com',
  'lnkd.in',
  'oribi.io',
];

const LIST_DOMAIN_INSTAGRAM = ['cdninstagram.com', 'ig.me', 'igsonar.com', 'instagram.com'];

const LIST_DOMAIN_YOUTUBE = [
  'googlevideo.com',
  'video.google.com',
  'video.l.google.com',
  'wide-youtube.l.google.com',
  'youtu.be',
  'youtube.ae',
  'youtube.al',
  'youtube.am',
  'youtube.at',
  'youtube.az',
  'youtube.ba',
  'youtube.be',
  'youtube.bg',
  'youtube.bh',
  'youtube.bo',
  'youtube.by',
  'youtube.ca',
  'youtube.cat',
  'youtube.ch',
  'youtube.cl',
  'youtube.co',
  'youtube.co.ae',
  'youtube.co.at',
  'youtube.co.cr',
  'youtube.co.hu',
  'youtube.co.id',
  'youtube.co.il',
  'youtube.co.in',
  'youtube.co.jp',
  'youtube.co.ke',
  'youtube.co.kr',
  'youtube.com',
  'youtube.co.ma',
  'youtube.com.ar',
  'youtube.com.au',
  'youtube.com.az',
  'youtube.com.bd',
  'youtube.com.bh',
  'youtube.com.bo',
  'youtube.com.br',
  'youtube.com.by',
  'youtube.com.co',
  'youtube.com.do',
  'youtube.com.ec',
  'youtube.com.ee',
  'youtube.com.eg',
  'youtube.com.es',
  'youtube.com.gh',
  'youtube.com.gr',
  'youtube.com.gt',
  'youtube.com.hk',
  'youtube.com.hn',
  'youtube.com.hr',
  'youtube.com.jm',
  'youtube.com.jo',
  'youtube.com.kw',
  'youtube.com.lb',
  'youtube.com.lv',
  'youtube.com.ly',
  'youtube.com.mk',
  'youtube.com.mt',
  'youtube.com.mx',
  'youtube.com.my',
  'youtube.com.ng',
  'youtube.com.ni',
  'youtube.com.om',
  'youtube.com.pa',
  'youtube.com.pe',
  'youtube.com.ph',
  'youtube.com.pk',
  'youtube.com.pt',
  'youtube.com.py',
  'youtube.com.qa',
  'youtube.com.ro',
  'youtube.com.sa',
  'youtube.com.sg',
  'youtube.com.sv',
  'youtube.com.tn',
  'youtube.com.tr',
  'youtube.com.tw',
  'youtube.com.ua',
  'youtube.com.uy',
  'youtube.com.ve',
  'youtube.co.nz',
  'youtube.co.th',
  'youtube.co.tz',
  'youtube.co.ug',
  'youtube.co.uk',
  'youtube.co.ve',
  'youtube.co.za',
  'youtube.co.zw',
  'youtube.cr',
  'youtube.cz',
  'youtube.de',
  'youtube.dk',
  'youtubeeducation.com',
  'youtube.ee',
  'youtubeembeddedplayer.googleapis.com',
  'youtube.es',
  'youtube.fi',
  'youtube.fr',
  'youtube.ge',
  'youtube.googleapis.com',
  'youtube.gr',
  'youtube.gt',
  'youtube.hk',
  'youtube.hr',
  'youtube.hu',
  'youtube.ie',
  'youtubei.googleapis.com',
  'youtube.in',
  'youtube.iq',
  'youtube.is',
  'youtube.it',
  'youtube.jo',
  'youtube.jp',
  'youtubekids.com',
  'youtube.kr',
  'youtube.kz',
  'youtube.la',
  'youtube.lk',
  'youtube.lt',
  'youtube.lu',
  'youtube.lv',
  'youtube.ly',
  'youtube.ma',
  'youtube.md',
  'youtube.me',
  'youtube.mk',
  'youtube.mn',
  'youtube.mx',
  'youtube.my',
  'youtube.ng',
  'youtube.ni',
  'youtube.nl',
  'youtube.no',
  'youtube-nocookie.com',
  'youtube.pa',
  'youtube.pe',
  'youtube.ph',
  'youtube.pk',
  'youtube.pl',
  'youtube.pr',
  'youtube.pt',
  'youtube.qa',
  'youtube.ro',
  'youtube.rs',
  'youtube.ru',
  'youtube.sa',
  'youtube.se',
  'youtube.sg',
  'youtube.si',
  'youtube.sk',
  'youtube.sn',
  'youtube.soy',
  'youtube.sv',
  'youtube.tn',
  'youtube.tv',
  'youtube.ua',
  'youtube.ug',
  'youtube-ui.l.google.com',
  'youtube.uy',
  'youtube.vn',
  'yt3.ggpht.com',
  'yt.be',
  'ytimg.com',
  'ytimg.l.google.com',
  'ytkids.app.goo.gl',
  'yt-video-upload.l.google.com',
];

export { LIST_DOMAIN_FACEBOOK, LIST_DOMAIN_TWITTER, LIST_DOMAIN_LINKEDIN, LIST_DOMAIN_INSTAGRAM, LIST_DOMAIN_YOUTUBE };
